import Marquee from "react-fast-marquee";
import { useLang } from "@/context/LanguageContext";

export default function BrandMarquee() {
  const { t } = useLang();
  const items = t.marquee;

  return (
    <section data-testid="marquee" className="relative border-y border-white/10 bg-navy-surface py-8 overflow-hidden">
      <Marquee speed={38} gradient={false} autoFill>
        {items.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-4xl md:text-5xl font-light tracking-tight text-[#F0F4F8]/25 px-8 whitespace-nowrap">
              {item}
            </span>
            <span className="text-cyan-precision text-2xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
